module.exports = __webpack_public_path__ + "img/Group 946.a10f3080.png";